import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import az from './locales/az.json';
import en from './locales/en.json';
import lt from './locales/lt.json';
import ru from './locales/ru.json';

// Bootstrap i18next early — App.tsx imports this for side effects so the
// translation function is available before any component renders.
//
// AZ is the default for the Azerbaijani market. Detection order:
//   1. cached selection in localStorage
//   2. browser language
//   3. fallback to AZ
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      az: { translation: az },
      en: { translation: en },
      ru: { translation: ru },
      lt: { translation: lt },
    },
    // LT is translated for the main UI; deep/rare strings fall back to EN.
    // Other languages keep the AZ fallback.
    fallbackLng: { lt: ['en'], default: ['az'] },
    supportedLngs: ['az', 'en', 'ru', 'lt'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'esd_lang',
    },
  });

export { i18n };
